import React from 'react'
import { K1Information } from '@e3dc-react/icons'
import { Stack, Typography } from '@mui/material'

interface Props {
  text: string
}

/**
 * This component displays an alert for price-based charging when energy cost are not dynamic.
 * energy costs are dynamic if (dynamic tariff, variable tariff or variable grid fees) are used.
 */
const PriceBasedChargingAlert: React.FC<Props> = ({ text }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        backgroundColor: 'shades.shade04',
        border: '1px solid',
        borderColor: 'shades.shade03',
        borderRadius: 2,
        padding: 2,
        marginBottom: 2,
      }}
    >
      <K1Information sx={{ color: 'grey.grey00', fontSize: 4 }} />
      <Typography variant="body2">{text}</Typography>
    </Stack>
  )
}

export default PriceBasedChargingAlert
